import { render } from "./ParkingSelection.vue?vue&type=template&id=2f142180&scoped=true"
import script from "./ParkingSelection.vue?vue&type=script&lang=js"
export * from "./ParkingSelection.vue?vue&type=script&lang=js"

import "./ParkingSelection.vue?vue&type=style&index=0&id=2f142180&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f142180"]])

export default __exports__